<script>
	import { onMount, setContext } from 'svelte';

	import { keyToken, keyUser } from './globals.js';

	import Alarms from './Alarms.svelte';
	import Login from './Login.svelte';
	import Navigation from './Navigation.svelte';
	import Portfolio from './Portfolio.svelte';
	import Watchlist from './Watchlist.svelte';
	import AddAlarmDialog from './components/dialog/AddAlarmDialog.svelte';
	import AssetDetails from './components/dialog/AssetDetails.svelte';
	import BuySellDialog from './components/dialog/BuySellDialog.svelte';
	import MessageDialog from './components/dialog/MessageDialog.svelte';
	import StockTicker from './components/StockTicker.svelte';

	setContext(keyToken, {
		getToken: () => token
	});

	setContext(keyUser, {
		getUser: () => user
	});

	let token;
	let user;

	let modalMessage;
	let modalType;
	let updates;

	$: if (token != null) {
		user = JSON.parse(atob(token.split('.')[1]));
		user.lastName = user.name;
		user.firstName = user.firstname;
		console.log('user', user);
	}

	function handleLogin(event) {
		console.log('handleLogin', event);
		event.detail.token.then(value => {
			token = value;
			if (event.detail.rememberMe) {
				document.cookie = 'token=' + encodeURIComponent(value) + '; samesite=strict; max-age=' + 5*24*60*60; // = 5 days
			}
		});
	}

	function handleLogout(event) {
		console.log('handleLogout', event);
		token = null;
		user = null;
		document.cookie = 'token=; samesite=strict; max-age=0'; // Clear the cookie by setting the maximum age to 0 seconds.
	}

	function clearMessage() {
		modalMessage = null;
		modalType = null;
	}

	function showMessage(event) {
		modalMessage = event.detail.text;
		modalType = event.detail.type;
	}

	function handleUpdate(event) {
		if (event != null && event.detail != null) {
			updates = event.detail;
		}
	}

	onMount(() => {
		let parts = ('; ' + document.cookie).split('; token=');
		if (parts.length === 2) {
			token = decodeURIComponent(parts.pop().split(';').shift());
		};
	});
</script>

<Navigation user={user} on:logout={handleLogout}/>

{#if token != null}
	<StockTicker on:update={handleUpdate}/>

	<Portfolio {updates} on:message={showMessage}/>

	<Watchlist {updates} on:message={showMessage}/>

	<Alarms {updates} on:message={showMessage}/>

	<AssetDetails on:message={showMessage} on:update={handleUpdate}/>

	<AddAlarmDialog on:message={showMessage} on:update={handleUpdate}/>

	<BuySellDialog on:message={showMessage} on:update={handleUpdate}/>

{:else}
	<Login on:login={handleLogin}/>
{/if}

<MessageDialog {modalMessage} {modalType} on:message={clearMessage}/>
